<template>
  <div class="flow">
    <popup :title="$t('view.settings.popup.unsaved.title')" ref="popupEditGuard">
      <div class="popup-subtext">{{ $t('view.settings.popup.unsaved.subtext') }}</div>
      <template v-slot:buttons>
        <btn icon="trash" color="red" @click="performViewAction()">{{ $t('btn.exit') }}</btn>
        <btn icon="undo" @click="cancelViewAction()">{{ $t('btn.cancel') }}</btn>
      </template>
    </popup>
    <div class="flow__sidebar">
      <div class="flow__sidebar-container">
        <draggable
          handle=".flow-group__drag-handler"
          v-model="flowGroups"
          :group="{ name: 'flow-groups' }"
          :move="groupMove"
          @update="groupMoved"
        >
          <flow-group
            v-for="group in flowGroups"
            :key="group.id"
            :group="group"
            @clearSelected="clearSelected"
            @selected="openBlock"
            ref="flowGroups"
          ></flow-group>
        </draggable>
      </div>
      <div class="flow__new-group" :class="{'flow__new-group--active': addMode}">
        <in class="flow__input" v-model="newGroup.name" maxlength="32" @enter="createGroup"></in>
        <btn class="flow__button" @click="createGroup" icon="plus" small>{{ $t('btn.create') }}</btn>
      </div>
      <span
        class="flow__sidebar-create"
        @click="addMode = !addMode"
      >{{ (addMode) ? $t('btn.cancel') : $t('view.flow.newGroup') }}</span>
    </div>
    <div class="flow__editor editor">
      <block-editor ref="blockEditor"></block-editor>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      addMode: false,
      newGroup: {
        name: 'New Group'
      },
      viewAction: null
    }
  },

  computed: {
    flowGroups: {
      get() {
        return this.$store.state.flowGroups
      },

      set(v) {
        this.$store.commit('LOAD_FLOW', v)
      }
    }
  },

  async created() {
    await this.$store.dispatch('loadFlowData', this)
    await this.$store.dispatch('loadFunctions', this)
  },

  beforeMount() {
    window.addEventListener('beforeunload', this.preventNavi)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNavi)
  },

  beforeRouteLeave(to, from, next) {
    if (this.$store.state.isEdited) {
      this.viewAction = next
      this.$refs.popupEditGuard.open()
      next(false)
    } else {
      next()
    }
  },

  methods: {
    clearSelected() {
      for (let group of this.$refs.flowGroups) {
        group.clearChoice()
      }
    },

    async createGroup() {
      try {
        const groupReq = await axios.post('/api/flow/group', {
          name: this.newGroup.name
        })
        groupReq.data.created.blocks = []
        this.$store.commit('PUSH_NEW_FLOW_GROUP', groupReq.data.created)
        this.newGroup.name = 'New group'
        this.addMode = false
        this.notify('success', 'view.flow.success.groupCreate')
      } catch (e) {
        console.error(e)
        this.notify('error', 'view.flow.error.groupCreate')
      }
    },

    openBlock(block) {
      this.$refs.blockEditor.load(block)
    },

    guardEdited(viewAction) {
      if (this.$store.state.isEdited) {
        this.$refs.popupEditGuard.open()
        this.viewAction = viewAction
      } else {
        viewAction()
      }
    },

    performViewAction() {
      this.viewAction()
      this.viewAction = null
      this.$store.commit('SET_EDITED', false)
      this.$refs.popupEditGuard.close()
    },

    cancelViewAction() {
      this.viewAction = null
      this.$refs.popupEditGuard.close()
    },

    preventNavi (event) {
      if (!this.$store.state.isEdited) return
      event.preventDefault()
      event.returnValue = ""
    },

    groupMove (e) {
      if (e.related.dataset.groupBuiltIn || e.dragged.dataset.groupBuiltIn) return false
      else return true
    },

    async groupMoved (e) {
      const eCp = e
      try {
        await axios.put('/api/flow/group/order', {
          id: +e.item.dataset.groupId,
          newIndex: e.newIndex
        })
      } catch (e) {
        const [el] = this.flowGroups.splice(eCp.newIndex, 1)
        this.flowGroups.splice(eCp.oldIndex, 0, el)
        console.error(e)
        this.notify('error', 'view.flow.error.groupMove')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flow {
  display: flex;
  max-width: calc(100vw - 122px);
  &__sidebar {
    @include viewSidebar();
    max-height: calc(100% - 15px);
    overflow-y: auto;
    padding-bottom: 15px;
  }

  &__sidebar-create {
    @include clickableText();
  }

  &__new-group {
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease;

    &--active {
      max-height: 150px;
    }
  }
}
</style>
